import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints } = constants;
const { xs } = breakpoints.BreakpointNames;

export const rootCss = {
  background: "transparent",
  marginBottom: "32px",

  [mediaQuery.upTo(xs)]: {
    padding: "8px",
  },
};
